import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TemplatesPage } from "@/features/worktemplates/TemplatesPage";

const search = z.object({
  kind: z.enum(["project", "playbook"]).optional(),
});

export const Route = createFileRoute("/_app/work/templates/")({
  validateSearch: search,
  component: () => <TemplatesPage search={Route.useSearch()} />,
});
